import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ContentAndStatus } from '../../Models/OtherClasses';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class SatisfactionSurveyResponseService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('SatisfactionSurveyResponse');
	}

	getForQuestion(id: System.Guid): Observable<TooBig4Car.Logic.SatisfactionSurveyResponse[]> {
		return this.myBaseService.loadAll(this.url + '/ForQuestion/' + (id || ''));
	}
	save(tempItem: TooBig4Car.Logic.SurveyResponse) : Observable<string> {
		return this.myBaseService.save(tempItem, this.url);
	}
	
	getEdit(id: System.Guid): Observable<ContentAndStatus<TooBig4Car.Logic.SurveyResponse>> {
		return this.myBaseService.getPlainErrorOptionWithStatusCode(this.url +'/Edit/'+(id||''), 'Failed to Load', true);
	}
	get(id: System.Guid) : Observable<TooBig4Car.Logic.SurveyResponse>{
		return this.myBaseService.get(id, this.url);
	}
}
				
